import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { ORG_LABELS } from '../config';
import { Tabs } from '../ui/basics';
import Candidates from './onboarding/Candidates';
import References from './onboarding/References';

const TABS = [
  { key: 'candidates', label: 'Candidate Offers' },
  { key: 'references', label: 'Client references & reminders' },
];

export default function Onboardings() {
  const { org } = useAuth();
  const [tab, setTab] = useState('candidates');
  return (
    <div className="stack">
      <div className="page-head"><div><h1>Onboardings</h1><p>{ORG_LABELS[org]} · candidate offers, documents and client requirements</p></div></div>
      <Tabs tabs={TABS} value={tab} onChange={setTab} />
      {tab === 'candidates' ? <Candidates key={org} org={org} /> : <References key={org} org={org} />}
    </div>
  );
}
